(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow-bodie"] && !Shopify.designMode) return;
  try {
    
  /**
   * Controlador do hero slideshow Bodie.
   * Gerencia troca de slides com autoplay opcional, setas e dots.
   */
  (function () {
    document.querySelectorAll('.hbs').forEach(function (section) {
      var slides   = Array.from(section.querySelectorAll('.hbs__slide'));
      var dots     = Array.from(section.querySelectorAll('.hbs__dot'));
      var btnPrev  = section.querySelector('.hbs__arrow--prev');
      var btnNext  = section.querySelector('.hbs__arrow--next');
      var total    = slides.length;
      var current  = 0;
      var timer    = null;
      var autoplay = section.dataset.autoplay === 'true';
      var speed    = parseInt(section.dataset.speed, 10) || 5000;

      if (total <= 1) return;

      /**
       * Ativa o slide no índice informado
       * @param {number} index - Índice do slide a exibir
       */
      function goTo(index) {
        slides[current].classList.remove('hbs__slide--active');
        slides[current].setAttribute('aria-hidden', 'true');
        if (dots[current]) {
          dots[current].classList.remove('hbs__dot--active');
          dots[current].setAttribute('aria-selected', 'false');
        }

        current = (index + total) % total;

        slides[current].classList.add('hbs__slide--active');
        slides[current].setAttribute('aria-hidden', 'false');
        if (dots[current]) {
          dots[current].classList.add('hbs__dot--active');
          dots[current].setAttribute('aria-selected', 'true');
        }
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startAutoplay() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(next, speed);
      }

      function resetAutoplay() {
        clearInterval(timer);
        startAutoplay();
      }

      if (btnNext) btnNext.addEventListener('click', function () { next(); resetAutoplay(); });
      if (btnPrev) btnPrev.addEventListener('click', function () { prev(); resetAutoplay(); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.index, 10));
          resetAutoplay();
        });
      });

      /* Pausa ao passar o mouse */
      section.addEventListener('mouseenter', function () { clearInterval(timer); });
      section.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
